<script lang="ts" module>
  export type Breadcrumb = {
    name: string;
    path: string;
  };
</script>

<script lang="ts">
  import { env } from '$env/dynamic/public';
  import type { BreadcrumbList, WithContext } from 'schema-dts';

  interface Props {
    items: Breadcrumb[];
  }

  let { items }: Props = $props();

  let breadcrumbList: WithContext<BreadcrumbList> = $derived({
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    itemListElement: items.map((item, i) => ({
      '@type': 'ListItem',
      position: i + 1,
      name: item.name,
      item: new URL(item.path, env.PUBLIC_BASE_URL).toString().replace(/\/$/, '')
    }))
  });
</script>

<template>
  {@html `<script type="application/ld+json">${JSON.stringify(breadcrumbList)}</script>`}
</template>
